import { hubAPI } from '@/lib/api';
import { getPublication, updatePublication } from '../prospect/attachments/publicationState';
import { toast } from 'sonner';

export async function publishProjectFiles(key, draft) {
    if (getPublication(key)?.status === 'sending') return;
    let current = { ...draft, status: 'sending', error: null, progress: {} };
    updatePublication(key, current);
    let message;
    try {
        if (!current.messageId) {
            const response = await hubAPI.createProjectWallMessage(current.projectId, current.text.trim(), current.mentions,
                { clientRequestId: current.requestId, skipRetry: true });
            message = response.data;
            current = { ...current, messageId: message.id };
            updatePublication(key, current, message);
        }
        for (const item of draft.files) {
            const response = await hubAPI.uploadProjectWallAttachment(current.projectId, current.messageId, item.file, event => {
                if (!event.total) return;
                const value = Math.floor(event.loaded / event.total * 10) * 10;
                if (current.progress[item.id] === value) return;
                current = { ...current, progress: { ...current.progress, [item.id]: value } };
                updatePublication(key, current);
            }, { clientRequestId: item.id, skipRetry: true });
            message = response.data;
            current = { ...current, files: current.files.filter(file => file.id !== item.id) };
            updatePublication(key, current, message);
        }
        if (!message) {
            const response = await hubAPI.listProjectWall(current.projectId);
            message = response.data.find(item => item.id === current.messageId);
        }
        updatePublication(key, null, message);
        toast.success('Message publié');
    } catch (error) {
        if (!current.messageId) {
            try {
                const response = await hubAPI.listProjectWall(current.projectId);
                const delivered = response.data.find(item => item.client_request_id === current.requestId);
                if (delivered) {
                    current = { ...current, messageId: delivered.id };
                    if (!current.files.length) { updatePublication(key, null, delivered); toast.success('Message publié'); return; }
                    updatePublication(key, current, delivered);
                }
            } catch { /* Le même identifiant sera repris au prochain clic. */ }
        }
        const detail = error.response?.data?.detail;
        current = { ...current, status: 'failed', error: typeof detail === 'string' ? detail : 'Envoi interrompu. Vos fichiers restent disponibles pour réessayer.' };
        updatePublication(key, current);
        toast.error(current.error);
    }
}